import {NetworkStep} from "@/pages/pagespeed/types.js";

// @ts-expect-error legacy
import DonutChart from "./DonutChart.jsx";

interface AnalysisData {
  loadingPerContentType: Record<string, number>;
  loadingPerDomain: Record<string, number>;
  sizePerContentType: Record<string, number>;
  sizePerDomain: Record<string, number>;
  requestsPerContentType: Record<string, number>;
  requestsPerDomain: Record<string, number>;
  type: Record<
    string,
    {
      time: number;
      size: number;
      count: number;
    }
  >;
  domain: Record<
    string,
    {
      time: number;
      size: number;
      count: number;
    }
  >;
}

interface PerformanceAnalysisProps {
  steps: NetworkStep[];
}

export const PerformanceAnalysis = ({steps}: PerformanceAnalysisProps) => {
  if (steps.length < 1) {
    return null;
  }

  const analysis: AnalysisData = {
    type: {},
    domain: {},
    loadingPerContentType: {},
    loadingPerDomain: {},
    sizePerContentType: {},
    sizePerDomain: {},
    requestsPerContentType: {},
    requestsPerDomain: {},
  };
  for (const r of steps) {
    const domain = r.url.split("/")[2];
    const resourceType = r.resourceType;
    if (!analysis.domain[domain]) {
      analysis.domain[domain] = {
        time: 0,
        size: 0,
        count: 0,
      };
    }
    if (!analysis.type[resourceType]) {
      analysis.type[resourceType] = {
        time: 0,
        size: 0,
        count: 0,
      };
    }
    let duration = r.timing.loadingFinished - r.timing.requestWillBeSent;
    if (r.fromCache) {
      duration = r.timing.receiveHeadersEnd;
    }

    analysis.domain[domain].time += duration || 0;
    analysis.domain[domain].size += r.size || 0;
    analysis.domain[domain].count += 1;
    analysis.type[resourceType].time += duration || 0;
    analysis.type[resourceType].size += r.size || 0;
    analysis.type[resourceType].count += 1;
  }

  const loadingPerContentType = Object.keys(analysis.type).reduce((acc, x) => {
    // @ts-expect-error unknown type
    acc[x] = Math.round(analysis.type[x].time);
    return acc;
  }, {});

  const loadingPerDomain = Object.keys(analysis.domain).reduce((acc, x) => {
    // @ts-expect-error unknown type
    acc[x] = Math.round(analysis.domain[x].time);
    return acc;
  }, {});

  const sizePerContentType = Object.keys(analysis.type).reduce((acc, x) => {
    // @ts-expect-error unknown type
    acc[x] = Math.round(analysis.type[x].size);
    return acc;
  }, {});

  const sizePerDomain = Object.keys(analysis.domain).reduce((acc, x) => {
    // @ts-expect-error unknown type
    acc[x] = Math.round(analysis.domain[x].size);
    return acc;
  }, {});

  const requestsPerContentType = Object.keys(analysis.type).reduce((acc, x) => {
    // @ts-expect-error unknown type
    acc[x] = Math.round(analysis.type[x].count);
    return acc;
  }, {});

  const requestsPerDomain = Object.keys(analysis.domain).reduce((acc, x) => {
    // @ts-expect-error unknown type
    acc[x] = Math.round(analysis.domain[x].count);
    return acc;
  }, {});

  analysis.loadingPerContentType = loadingPerContentType;
  analysis.loadingPerDomain = loadingPerDomain;
  analysis.sizePerContentType = sizePerContentType;
  analysis.sizePerDomain = sizePerDomain;
  analysis.requestsPerContentType = requestsPerContentType;
  analysis.requestsPerDomain = requestsPerDomain;

  const formatTime = (x: number) => x.toString() + " ms";
  const formatBytes = (x: number) => Math.round(x / 1024.0).toString() + " KB";
  const formatRequests = (x: number) => x.toString() + " requests";
  return (
    <div className="row">
      <DonutChart
        id="loading-per-content-type-chart"
        title="Loading Time per Content Type"
        data={analysis.loadingPerContentType}
        tooltipFn={formatTime}
      />
      <DonutChart
        id="loading-per-domain-chart"
        title="Loading Time per Domain"
        data={analysis.loadingPerDomain}
        tooltipFn={formatTime}
        collapseSeries={7}
      />
      <DonutChart
        id="size-per-content-type-chart"
        title="Size per Content Type"
        data={analysis.sizePerContentType}
        tooltipFn={formatBytes}
      />
      <DonutChart
        id="size-per-domain-chart"
        title="Size per Domain"
        data={analysis.sizePerDomain}
        tooltipFn={formatBytes}
        collapseSeries={7}
      />
      <DonutChart
        id="requests-per-content-type-chart"
        title="Requests per Content Type"
        data={analysis.requestsPerContentType}
        tooltipFn={formatRequests}
      />
      <DonutChart
        id="requests-per-domain-chart"
        title="Requests per Domain"
        data={analysis.requestsPerDomain}
        tooltipFn={formatRequests}
        collapseSeries={7}
      />
    </div>
  );
};
